module.exports = __webpack_public_path__ + "img/10_sherry_s.b264ed2a.png";